import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch } from 'store/store';
import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import {
  fetchSocialNets,
  selectSocialNets,
  selectSocialNetTournamentId,
  selectStatus,
  setTournamentId,
} from '../../store/social-nets';

function useSocialNets() {
  const dispatch = useDispatch<AppDispatch>();
  const tournamentId = useSelector(authStoreUserTournamentId);
  const socialNet = useSelector(selectSocialNets);
  const socialNetTournamentId = useSelector(selectSocialNetTournamentId);
  const status = useSelector(selectStatus);

  useEffect(() => {
    if (tournamentId && !status.isLoading && (!status.isLoaded || socialNetTournamentId !== tournamentId)) {
      dispatch(fetchSocialNets());
      dispatch(setTournamentId(tournamentId));
    }
  }, [dispatch, socialNetTournamentId, status.isLoaded, status.isLoading, tournamentId]);

  return { socialNet, ...status };
}

export default useSocialNets;
